import React from 'react'
import { FaArrowDown, FaArrowUp } from 'react-icons/fa'
import classnames from 'classnames'
import './assets/scss/styles.scss'

export default function ArrowPaginator({current, upDisabled, downDisabled, lastTerm, firstTerm}) {

    function _handleClickArrow(direction){
       if (direction === "up"){ current(direction)}
       if (direction === "down"){ current(direction)}
    }

    return (
        <div className='arrows'>
            <span className={classnames('arrow-up', {disabled: upDisabled, lighted: firstTerm})}><FaArrowUp onClick={() => !upDisabled && _handleClickArrow('up')}/></span>
            <span className={classnames('arrow-down', {disabled: downDisabled, lighted: lastTerm})}><FaArrowDown onClick={() => !downDisabled && _handleClickArrow('down')}/></span>
        </div>
    )
}
